import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dimensions, View, Text, StyleSheet, TouchableOpacity } from 'react-native';

import Colors from '../../constants/Colors';
import timeUtils from '../../utils/timeUtils';
import PantryPhoto from './PantryPhoto';

class PantryListItem extends PureComponent {
  static propTypes = {
    item: PropTypes.objectOf(PropTypes.any).isRequired,
    onSelect: PropTypes.func.isRequired,
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    locale: PropTypes.string.isRequired,
  };

  constructor(props) {
    super();
  }

  render() {
    const { item, onSelect, translation, locale } = this.props;
    let serviceType = null;
    item.service_hours = item.service_hours || item.services;
    const services = [];
    if (item.service_hours && item.service_hours.length && typeof item.service_hours !== 'string') {
      item.service_hours.slice(0, 10).forEach((service, index) => {
        if (!serviceType) {
          serviceType = service.type;
        } else if (serviceType !== service.type) {
          // we only want the same type in the list
          return;
        }
        const text = timeUtils.getServiceRow(service, translation);
        services.push(
          <View style={styles.serviceLine} key={`Service-${item.id}-${index}`}>
            <Text style={styles.serviceText}>{text}</Text>
          </View>
        );
      });
    }

    const serviceTypeDisplay =
      serviceType === 'reservation' || serviceType?.includes('appointment')
        ? translation.app_servicekind_reservations
        : translation.app_servicekind_line;

    let visitLabel = null;
    if (item.visit) {
      const timeLabel = timeUtils.timeSinceMidnightToString(item.visit.time);
      if (item.visit.today) {
        visitLabel = `${translation.visit_group} ${item.visit.group_id}, ${translation.visit_come_by} ${timeLabel}`;
      } else {
        const dateLabel = timeUtils.getDateYear(item.visit.date * 1000, locale);
        visitLabel = `${translation.cell_pantry_short_visit_date} ${dateLabel}, ${timeLabel}`;
      }
    }

    const programsLabels = [];
    if (item.programs && item.programs.length) {
      item.programs.forEach((program) => {
        const programLabel = program.toLowerCase().replace(/ /g, '_');
        programsLabels.push(translation[`program_type_${programLabel}`]);
      });
    }
    const programsLabel = programsLabels.sort().join(', ');

    return (
      <TouchableOpacity style={styles.container} onPress={onSelect}>
        <PantryPhoto url={item.avatar || item.small_photo_url} distance={0.5} />
        <View style={styles.pantryDetailsTextContainer}>
          <Text style={styles.pantryDetailsName}>{item.name}</Text>
          <Text style={styles.programsLabel}>{programsLabel}</Text>
          {visitLabel && <Text style={styles.visitLabel}>{visitLabel}</Text>}
          {serviceType && <Text style={styles.serviceTypeLabel}>{serviceTypeDisplay}</Text>}
          {services}
          <Text onPress={onSelect} style={styles.link}>
            {translation.view_pantry}
          </Text>
        </View>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    borderTopColor: Colors.grayBorder,
    borderTopWidth: 1,
    padding: 16,
  },
  pantryDetailsTextContainer: {
    paddingLeft: 16,
    width: Dimensions.get('window').width - 112,
  },
  pantryDetailsName: {
    flexWrap: 'wrap',
    fontFamily: 'roboto-regular',
    color: Colors.veryDarkGray,
    fontSize: 16,
    fontWeight: '600',
  },
  programsLabel: {
    flexWrap: 'wrap',
    fontFamily: 'roboto-regular',
    color: Colors.veryDarkGray,
    fontSize: 12,
    fontWeight: '400',
  },
  visitLabel: {
    flexWrap: 'wrap',
    fontFamily: 'roboto-regular',
    color: Colors.primaryColor,
    fontSize: 12,
    lineHeight: 18,
    marginTop: 4,
  },
  serviceTypeLabel: {
    color: Colors.primaryColor,
    textTransform: 'capitalize',
    fontSize: 12,
    lineHeight: 16,
    fontWeight: 'bold',
    marginTop: 12,
  },
  serviceText: {
    fontSize: 12,
    lineHeight: 16,
    color: Colors.veryDarkGray,
    fontWeight: '600',
  },
  link: {
    fontFamily: 'roboto-regular',
    color: Colors.primaryColor,
    fontSize: 12,
    fontWeight: '600',
    marginTop: 8,
    textDecorationLine: 'underline',
    textTransform: 'uppercase',
  },
});

export default PantryListItem;

// item data: {
//   "id": 67,
//   "latitude": 40.638996,
//   "longitude": -73.958687,
//   "name": "Fort Greene Hazel Brooks Neighborhood Center",
//   "service_hours": Array [
//     Object {
//       "date": "2020-06-18",
//       "from": 39600,
//       "type": "first_come_first_serve",
//       "until": 45000,
//     },
//     Object {
//       "date": "2020-06-25",
//       "from": 37800,
//       "type": "appointments",
//       "until": 48600,
//     },
//   ],
//   "small_photo_url": "https://s3.amazonaws.com/nyc-fac-dev/images/7b701f06-4cc7-4136-9866-dc61fb791589.jpg",
//   "subscribed": null,
//   "type": "food_and_kitchen",
// },
